import { render, staticRenderFns } from "./_arrears.vue?vue&type=template&id=ab59008c"
import script from "./_arrears.vue?vue&type=script&lang=js"
export * from "./_arrears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports